<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer" :class="{'layer--nobutton': exportStep != 6}">
      <div class="layer__header">
        <!-- 상품 반출 준비 중 팝업 문구 -->
        <div v-if="exportStep == 2 || exportStep == 1">
          <div class="lyr-title">{{ $t('User.WineFinish.msg5') }}({{ itemNum + 1 }}/{{ totalCnt }})</div>
          <div class="ft-point">{{ $t('User.WineFinish.msg6') }}</div>
        </div>

        <!-- 와인 꺼내주세요 팝업 문구 -->
        <div v-if="exportStep == 4">
          <div class="lyr-title">{{ $t('User.WineFinish.msg7') }}({{ itemNum + 1 }}/{{ totalCnt }})</div>
          <div class="ft-point">{{ $t('User.WineFinish.msg8') }}</div>
        </div>

        <!-- 문 닫아주세요 팝업 문구 -->
        <div v-if="exportStep == 5">
          <div class="lyr-title">{{ $t('User.WineFinish.msg9') }}({{ itemNum + 1 }}/{{ totalCnt }})</div>
          <div class="ft-point">{{ $t('User.WineFinish.msg10') }}</div>
        </div>

        <!-- 상품 반출 완료 팝업 문구 -->
        <div v-else-if="exportStep == 6">
          <div class="lyr-title">{{ $t('User.WineFinish.msg9') }}({{ itemNum + 1 }}/{{ totalCnt }})</div>
          <div class="ft-point">{{ $t('User.WineFinish.msg11') }}</div>
        </div>

        <div v-if="exportStep != 6">
          <div class="lyr-txt">{{ $t('User.WineFinish.msg17') }}</div>
          <div class="lyr-txt tasting-num ft-point">{{ strToInt(wineColumn) }}{{ $t('User.WineFinish.msg4') }}</div>
        </div>
      </div>
      <div
        class="layer__body"
        @mouseup="
          if (nextNum == 0) nextTimeout();
          nextStep();
        "
      >
        <img v-if="exportStep != 6" src="@/assets/images/user/artwork_popup_wine_buy_3d.gif" alt="" class="img-size" />
        <img v-if="exportStep == 6" src="@/assets/images/user/img_buy_fin.png" alt="" class="img-size" />
      </div>
      <div class="layer__button" v-if="exportStep == 6 && finishYn && itemNum + 1 == totalCnt">
        <button class="btn btn--color btn--xlg btn-anim" @mouseup="setComplete">{{ $t('User.WineFinish.msg99') }}</button>
      </div>
      <div class="layer__button" v-if="failYn">
        <button class="btn btn--color btn--xlg btn-anim" @mouseup="dischargeCall">{{ $t('User.WineFinish.msg98') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'wineExport',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      exportStep: 2,
      orgBaskets: this.$store.getters.getOrgBaskets,
      itemNum: 0,
      failYn: false,
      nextNum: 0,
      finishYn: false,
    };
  },
  mounted() {
    this.dischargeCall();
  },
  props: {
    wineTran: String,
  },
  methods: {
    nextStep() {
      this.nextNum++;
      if (this.nextNum >= 10) {
        if (this.itemNum + 1 < this.totalCnt) {
          this.itemNum++;
          this.exportStep = 2;
          this.nextNum = 0;
          this.dischargeCall();
        } else {
          this.exportStep = 6;
          this.finishYn = true;
        }
      }
    },
    nextTimeout() {
      setTimeout(() => {
        if (this.nextNum < 10) {
          this.nextNum = 0;
        }
      }, 5000);
    },
  
    strToInt(val) {
      var regex = /[^0-9]/g;
      var result = Number(val.replace(regex, ''));
      return result;
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    erpArray: function () {
      let arr = [];
      this.orgBaskets.forEach((basket) => {
        for (let i = 0; i < basket.SALES_QTY; i++) {
          arr.push(basket.ERP_ITEM_CD);
        }
      });
      return arr;
    },
    wineColumn: function () {
      return this.erpArray[this.itemNum];
    },
    totalCnt: function () {
      let sum = 0;
      this.orgBaskets.forEach((basket) => {
        sum += basket.SALES_QTY;
      });
      return sum;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped>
.tasting-num {
  font-size: 3em;
}
</style>
